// extracted by mini-css-extract-plugin
export default {"header":"styles_header__3MDFs","title":"styles_title__C1BQY","form":"styles_form__hoau2","formButton":"styles_formButton__wUkjY","auxilliaryText":"styles_auxilliaryText__hS8WN"};